import { modal } from '../types';

const INITIAL_STATE = {
    isTextModalOpen: false,
    isCustomModalOpen: false,
    isSmallCustomModalOpen: false,
    heading: '',
    text: '',
    type: '',
    buttons: [],
    modalComponent: '',
    closeOnBackdropClick: true
}

const modalreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
       
        case modal.OPEN_CUSTOM_MODAL:
            return {
                ...state,
                isCustomModalOpen:true,
                modalComponent: action.payload.modalComponent,
                heading:action.payload.heading,
                modalWidth:action.payload.modalWidth, 
                modalHeight:action.payload.modalHeight
            }
        case modal.CLOSE_MODAL:
            return INITIAL_STATE
        default:
            return state
    }
}

export default modalreducer